'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _request = require('request');

var _request2 = _interopRequireDefault(_request);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Regions = function (_React$Component) {
	_inherits(Regions, _React$Component);

	function Regions(props) {
		_classCallCheck(this, Regions);

		var _this = _possibleConstructorReturn(this, (Regions.__proto__ || Object.getPrototypeOf(Regions)).call(this, props));

		_this.state = {
			regions: JSON.parse(JSON.stringify(INITIAL_REGIONS)),
			selectedIndex: false,
			saving: []
		};
		_this.renderRegions = _this._renderRegions.bind(_this);
		_this.renderAddRegion = _this._renderAddRegion.bind(_this);
		_this.handleAddRegion = _this._handleAddRegion.bind(_this);
		_this.saveRegion = _this._saveRegion.bind(_this);
		_this.inputFields = [];

		window.onbeforeunload = _this.canLeave;
		return _this;
	}

	_createClass(Regions, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(
				'div',
				{ className: 'regions' },
				this.renderRegions(),
				this.renderAddRegion()
			);
		}
	}, {
		key: '_renderRegions',
		value: function _renderRegions() {
			var _this2 = this;

			var _state = this.state,
			    regions = _state.regions,
			    saving = _state.saving;


			return regions.map(function (region, i) {

				var selected = i === _this2.state.selectedIndex;
				var isSaving = saving.indexOf(i) > -1;

				return _react2.default.createElement(
					'div',
					{ className: (0, _classnames2.default)('region', { "show-edit": selected, isSaving: isSaving }), key: i },
					_react2.default.createElement(
						'div',
						{ className: 'edit closed-options', onClick: _this2._handleToggleEdit.bind(_this2, i) },
						_react2.default.createElement('i', { className: 'fa fa-pencil' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'edit open-options', onClick: _this2._handleToggleEdit.bind(_this2, i) },
						_react2.default.createElement(
							'span',
							{ onClick: _this2._handleSave.bind(_this2, i) },
							'Save'
						),
						' | ',
						_react2.default.createElement(
							'span',
							{ onClick: _this2._handleCancel.bind(_this2, i) },
							'Cancel'
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'edit saving-icon' },
						_react2.default.createElement('i', { className: 'fa fa-circle-o-notch fa-spin' })
					),
					_react2.default.createElement(
						'label',
						{ htmlFor: region.slug },
						'Region Name'
					),
					_react2.default.createElement('input', {
						ref: function ref(elem) {
							_this2.inputFields[i] = elem;
						},
						id: region.slug,
						type: 'text',
						value: region.name,
						name: region.slug,
						disabled: !selected,
						onChange: _this2._handleNameChange.bind(_this2, i) })
				);
			});
		}
	}, {
		key: '_renderAddRegion',
		value: function _renderAddRegion() {
			return _react2.default.createElement(
				'div',
				{ className: 'add-region', onClick: this.handleAddRegion },
				_react2.default.createElement(
					'div',
					{ className: 'ix ix-plus' },
					'+'
				),
				' Add Region'
			);
		}
	}, {
		key: '_handleAddRegion',
		value: function _handleAddRegion() {
			var _this3 = this;

			var _state2 = this.state,
			    regions = _state2.regions,
			    selectedOriginal = _state2.selectedOriginal,
			    selectedIndex = _state2.selectedIndex;


			if (selectedIndex) {
				regions[selectedIndex].name = selectedOriginal;
			}

			regions.push({ name: '', slug: 'new[]', id: 'new' });

			this.setState({
				selectedIndex: regions.length - 1,
				selectedOriginal: '',
				regions: regions
			}, function () {
				var field = _this3.inputFields[regions.length - 1];
				field.focus();
				field.setSelectionRange(0, 0);
			});
		}
	}, {
		key: '_handleNameChange',
		value: function _handleNameChange(index, e) {
			var regions = this.state.regions;

			regions[index].name = e.target.value;
			this.setState({
				regions: regions
			});
		}
	}, {
		key: '_handleToggleEdit',
		value: function _handleToggleEdit(index) {
			var field = this.inputFields[index];
			var _state3 = this.state,
			    regions = _state3.regions,
			    selectedOriginal = _state3.selectedOriginal,
			    selectedIndex = _state3.selectedIndex,
			    saving = _state3.saving;


			if (saving.indexOf(index) > -1) {
				return;
			}

			if (selectedIndex !== false && regions[selectedIndex].name !== selectedOriginal) {
				return;
			}
			this.setState({
				selectedIndex: index,
				selectedOriginal: this.state.regions[index].name
			}, function () {
				field.focus();
				field.setSelectionRange(0, field.value.length);
			});
		}
	}, {
		key: '_handleSave',
		value: function _handleSave(index) {
			var _this4 = this;

			var region = this.state.regions[index];
			var saving = this.state.saving;


			if (saving.indexOf(index) > -1) {
				return;
			}

			saving.push(index);

			this.setState({
				saving: saving
			}, function () {

				_this4.saveRegion(region.id, region.name, index);
			});
		}
	}, {
		key: '_saveRegion',
		value: function _saveRegion(id, name, itemIndex) {
			var _this5 = this;

			_request2.default.post({
				url: location.origin + '/ajax/region/' + id,
				headers: {
					'Content-Type': 'application/json',
					'X-CSRF-TOKEN': CSRF_TOKEN
				},
				form: { name: name }
			}, function (err, response, body) {
				if (err) {
					console.log(err);
					return;
				}
				var region = JSON.parse(body);

				var _state4 = _this5.state,
				    saving = _state4.saving,
				    regions = _state4.regions,
				    selectedIndex = _state4.selectedIndex;


				var index = saving.indexOf(itemIndex);
				saving.splice(index, 1);

				regions[itemIndex] = region;

				if (itemIndex === selectedIndex) {
					selectedIndex = false;
				}

				_this5.setState({
					saving: saving,
					regions: regions,
					selectedIndex: selectedIndex
				});
			});
		}
	}, {
		key: '_handleCancel',
		value: function _handleCancel(index, e) {
			e.stopPropagation();
			var _state5 = this.state,
			    regions = _state5.regions,
			    selectedOriginal = _state5.selectedOriginal;

			regions[index].name = selectedOriginal;

			this.setState({
				selectedIndex: false,
				selectedOriginal: '',
				regions: regions
			});
		}
	}, {
		key: 'canLeave',
		value: function canLeave(e) {

			return null;

			var message = "Are you sure you want to leave?";
			e.returnValue = message;
			return message;
		}
	}]);

	return Regions;
}(_react2.default.Component);

exports.default = Regions;


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/settings/Regions.js
// module id = 523
// module chunks = 0